import Collapse from 'bootstrap/js/dist/collapse';

function NotificationBanner()
{
    const notificationBannerCollapse = document.getElementById('notificationBannerCollapse');
    const bannerCloseButton = (notificationBannerCollapse !== null) ? notificationBannerCollapse.querySelector('.alert-btn-close') : null;

    if (notificationBannerCollapse === null) {
        return;
    }

    const bannerCollapse = new Collapse(notificationBannerCollapse, {
        toggle: false
    });

    // check cookie and show banner if not dismissed
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const bannerCookie = cookies.find(cookie => cookie.startsWith('bf_banner='));
    if (!bannerCookie) {
        bannerCollapse.show();
    } else {
        const cookieValue = bannerCookie.split('=')[1];
        const bannerHash = notificationBannerCollapse.dataset?.hash;
        if (cookieValue !== bannerHash) {
            bannerCollapse.show();
        }
    }

    // Close banner and set cookie
    if (bannerCloseButton !== null) {
        bannerCloseButton.addEventListener('click', event => {
            event.preventDefault();
            const domain = window.location.hostname.replace(/(www)\./, '');
            const secure = (location.protocol === 'https') ? 'secure;' : '';
            requestAnimationFrame(() => {
                setTimeout(() => {
                    bannerCollapse.hide();
                    document.cookie = 'bf_banner=' + notificationBannerCollapse.dataset?.hash + ';path=/;domain=' + domain + ';max-age=2147483647;samesite=strict;' + secure;
                }, 0);
            });
        });
    }
}

export default NotificationBanner;
    